import { Outlet } from "react-router-dom"

const Admin = () => {
	return (
		<div className="App">
			<Outlet />
		</div>
	)
}

export default Admin
